import { StateCreator } from 'zustand';
import {
  ActionItems,
  Alerts,
  DashboardStore
} from '@interfaces/dashboard-store';

const initialState = {
  alerts: [] as Alerts[],
  actionItems: [] as ActionItems[]
};

export const DashboardSlice: StateCreator<DashboardStore> = (set) => ({
  ...initialState,
  updateActionItems: (actionItems: ActionItems[]) =>
    set({ actionItems: actionItems }),
  resetDashboardStore: () => set(initialState),
  updateAlertsDashBoard: (alerts: Alerts[]) => set({ alerts: alerts })
});
